import authStorage from './authStorage'
import { API_URL } from './constants'
import refreshAccessToken from './refreshTokens'

async function swrFetcher(url, signal) {
    const opts = {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + authStorage.getItem('access_token'),
        },
        signal,
    }

    let response = await fetch(API_URL + url, opts)

    const isJSON = response.headers
        .get('content-type')
        ?.includes('application/json')

    if (!isJSON) throw new Error('Unknown error: invalid JSON')
    let data = await response.json()

    if (!response.ok && response.status === 401) {
        let canRefreshToken = true
        if (data.message !== 'Please authenticate') canRefreshToken = false
        const refreshToken = authStorage.getItem('refresh_token')
        if (!refreshToken) canRefreshToken = false
        if (!canRefreshToken) throw new Error('Unauthenticated')

        const newToken = await refreshAccessToken()
        opts.headers['Authorization'] = `Bearer ${newToken}`
        response = await fetch(API_URL + url, opts)
        const isJSON = response.headers
            .get('content-type')
            ?.includes('application/json')

        if (!isJSON) throw new Error('Unknown error: invalid JSON')
        data = await response.json()
    } else if (!response.ok) {
        const error = new Error(
            data.message || `Unknown error ${response.status}`,
        )
        error.status = response.status
        throw error
    }

    return data
}

export default swrFetcher
